export default function setDate(date: string) {
    const realDeadLine = new Date(date);
    return realDeadLine.toJSON();
}